import { connect } from 'react-redux'
import SearchBarView from './SearchBar.component'
import {
  setOperacion,
  togglePanel,
  setPropertyType,
  retriveFilters,
  changeSearchOrigin,
  saveOriginPathByPropertyType,
  resetForm,
  setTerrainSync,
  resetPropertyType,
} from '../../../actions/searchBar'
import { resetEntrepreneurshipId } from '../../../actions/entrepreneurship'
import { searchPropiedades } from '../../../actions/propiedades'

const mapStateToProps = (state) => {
  return {
    operation_types: state.propiedades.operation_types,
    property_types: state.propiedades.property_types,
    all_property_types: state.searchBar.all_property_types,
    property_types_loading: state.propiedades.property_types_loading,
    operation: state.searchBar.operation_type,
    property_type: state.searchBar.property_type,
    zona: state.searchBar.zona,
    show: state.searchBar.show,
    sub_property_type: state.searchBar.sub_property_type,
    originPath: state.searchBar.originPath,
    originOffice: state.searchBar.originOffice,
    store: state,
    landUses: state.terrains.uses,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectOperation: value => dispatch(setOperacion(value)),
    onSelectPropertyType: value => dispatch(setPropertyType(value)),
    onClickOpen: () => dispatch(togglePanel()),
    didMount: (section) => {
      dispatch(retriveFilters(section))
      dispatch(changeSearchOrigin())
    },
    setPropertyType: (value) => dispatch(setPropertyType(value)),
    resetForm: () => dispatch(resetForm()),
    resetEntrepreneurshipId: () => dispatch(resetEntrepreneurshipId()),
    closeMoreOptions: () => dispatch(togglePanel()),
    saveOriginPathByPropertyType: (value) => dispatch(saveOriginPathByPropertyType(value)),
    searchPropiedades: () => dispatch(searchPropiedades()),
    setLandUse: (value) => dispatch(setTerrainSync(value)),
    resetPropertyType: () => dispatch(resetPropertyType()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBarView)



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/SearchBar.container.js